import {
  AllProvidersModal,
  ChartsFilter,
  getGroupByType,
  getLocationsOverview,
  GetLocationsOverviewParams,
  getTimeZone,
  GroupByType,
  LocationEntity,
  OrdersCharts,
  OrdersOverviewEntity,
  PeriodType,
  reportError,
} from '@vgrubs/components';
import { DateTime } from 'luxon';
import { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { AllProvidersModalComponent } from '../../../../../components/src/shared/dashboard/AllProvidersModalComponent';
import { ServiceValueCards } from './insights';

export const LocationAnalyticsSection = ({
  data,
  showServiceValue,
}: {
  data: LocationEntity;
  /** What the client made with us and we with it: admin and support only. */
  showServiceValue: boolean;
}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [loadingOverview, setLoadingOverview] = useState(false);
  const [overview, setOverview] = useState<OrdersOverviewEntity | null>(null);

  const [allProvidersModal, setAllProvidersModal] =
    useState<AllProvidersModal | null>(null);
  const { id } = useParams() as { id: string };
  const from =
    searchParams.get('from') || DateTime.now().startOf('month').toISODate();
  const to =
    searchParams.get('to') || DateTime.now().startOf('day').toISODate();
  const groupByType = getGroupByType(from, to);

  async function getOverview(groupByType: GroupByType) {
    if (data.deleted) return;
    try {
      setLoadingOverview(true);

      const params: GetLocationsOverviewParams = {
        periodType: PeriodType.CUSTOM,
        groupByType,
        from: DateTime.fromISO(from).startOf('day').toISODate() || '',
        to: DateTime.fromISO(to).endOf('day').toISODate() || '',
        timeZone: getTimeZone,
      };

      const { data: overview } = await getLocationsOverview(id, params);

      setOverview(overview.data);
    } catch (error) {
      reportError(error);
    } finally {
      setLoadingOverview(false);
    }
  }

  useEffect(() => {
    if (data.deleted) return;
    getOverview(groupByType);
  }, [from, to]);

  useEffect(() => {
    if (data.deleted) return;
    getOverview(groupByType);
  }, [data.deleted]);

  return (
    <>
      {/* All time, so above the date picker: it does not change them.
          Shown for a deleted location too: what it made and cost is still
          worth knowing when its debt is being chased. */}
      {showServiceValue && <ServiceValueCards locationId={id} />}
      <ChartsFilter from={from} to={to} setSearchParams={setSearchParams} />
      <OrdersCharts
        data={overview}
        loading={loadingOverview}
        setAllProvidersModal={setAllProvidersModal}
        groupByType={groupByType}
      />
      <AllProvidersModalComponent
        allProvidersModal={allProvidersModal}
        setAllProvidersModal={setAllProvidersModal}
      />
    </>
  );
};
